var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 81,
    fill: "#1A5050",
    stroke: "#333333",
    strokeWidth: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 86C53.3431 86 52 87.3431 52 89C52 90.6569 53.3431 92 55 92V86ZM125.121 91.1213C126.293 89.9497 126.293 88.0503 125.121 86.8787L106.029 67.7868C104.858 66.6152 102.958 66.6152 101.787 67.7868C100.615 68.9584 100.615 70.8579 101.787 72.0294L118.757 89L101.787 105.971C100.615 107.142 100.615 109.042 101.787 110.213C102.958 111.385 104.858 111.385 106.029 110.213L125.121 91.1213ZM55 92H123V86H55V92Z",
    fill: "#00FF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b469644a0b816a291365ac1c7800d85a.svg";
export { ForwardRef as ReactComponent };